//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './TimeZoneSettingsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type TimeZoneSettingsUpdateTimeZoneSettingsQueryParameters = {
  timezone?: string | undefined ;
}

export function timeZoneSettingsGetUrl(): string {
  let url_ = getBaseUrl() + "/api/setting-management/timezone";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let timeZoneSettingsGetDefaultOptions: Omit<UseQueryOptions<string, unknown, string>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<string, unknown, string>, 'queryFn'>> = {
};
export function getTimeZoneSettingsGetDefaultOptions() {
  return timeZoneSettingsGetDefaultOptions;
};
export function setTimeZoneSettingsGetDefaultOptions(options: typeof timeZoneSettingsGetDefaultOptions) {
  timeZoneSettingsGetDefaultOptions = options;
}

export function timeZoneSettingsGetQueryKey(): QueryKey;
export function timeZoneSettingsGetQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'TimeZoneSettingsClient',
      'timeZoneSettingsGet',
    ]);
}
export function __timeZoneSettingsGet(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.timeZoneSettingsGet(
axiosConfig    );
}

/**
 * @return OK
 */
export function useTimeZoneSettingsGetQuery<TSelectData = string, TError = unknown>(options?: Omit<UseQueryOptions<string, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useTimeZoneSettingsGetQuery<TSelectData = string, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<string, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<string, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __timeZoneSettingsGet(context, axiosConfig) : __timeZoneSettingsGet,
    queryKey: timeZoneSettingsGetQueryKey(),
    ...timeZoneSettingsGetDefaultOptions as unknown as Omit<UseQueryOptions<string, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setTimeZoneSettingsGetData(queryClient: QueryClient, updater: (data: string | undefined) => string, ) {
  queryClient.setQueryData(timeZoneSettingsGetQueryKey(),
    updater
  );
}

/**
 * @return OK
 */
export function setTimeZoneSettingsGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: string | undefined) => string) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function timeZoneSettingsUpdateUrl(timezone?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/setting-management/timezone?";
if (timezone === null)
    throw new Error("The parameter 'timezone' cannot be null.");
else if (timezone !== undefined)
    url_ += "timezone=" + encodeURIComponent("" + timezone) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function timeZoneSettingsUpdateMutationKey(timezone?: string | undefined): MutationKey {
  return trimArrayEnd([
      'TimeZoneSettingsClient',
      'timeZoneSettingsUpdate',
      timezone as any,
    ]);
}

/**
 * @param timezone (optional) 
 * @return OK
 */
export function useTimeZoneSettingsUpdateMutation<TContext>(timezone?: string | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = timeZoneSettingsUpdateMutationKey(timezone);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.timeZoneSettingsUpdate(timezone),
    mutationKey: key,
  });
}
  
type TimeZoneSettingsUpdate__MutationParameters = TimeZoneSettingsUpdateTimeZoneSettingsQueryParameters

/**
 * @param timezone (optional) 
 * @return OK
 */
export function useTimeZoneSettingsUpdateMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, TimeZoneSettingsUpdate__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: TimeZoneSettingsUpdateTimeZoneSettingsQueryParameters}): UseMutationResult<void, unknown, TimeZoneSettingsUpdate__MutationParameters, TContext> {
  const key = timeZoneSettingsUpdateMutationKey(options?.parameters?.timezone!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: TimeZoneSettingsUpdate__MutationParameters) => Client.timeZoneSettingsUpdate(data.timezone ?? options?.parameters?.timezone!),
  mutationKey: key,
});
}
  
export function timeZoneSettingsGetTimezonesUrl(): string {
  let url_ = getBaseUrl() + "/api/setting-management/timezone/timezones";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let timeZoneSettingsGetTimezonesDefaultOptions: Omit<UseQueryOptions<Types.NameValue[], unknown, Types.NameValue[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.NameValue[], unknown, Types.NameValue[]>, 'queryFn'>> = {
};
export function getTimeZoneSettingsGetTimezonesDefaultOptions() {
  return timeZoneSettingsGetTimezonesDefaultOptions;
};
export function setTimeZoneSettingsGetTimezonesDefaultOptions(options: typeof timeZoneSettingsGetTimezonesDefaultOptions) {
  timeZoneSettingsGetTimezonesDefaultOptions = options;
}

export function timeZoneSettingsGetTimezonesQueryKey(): QueryKey;
export function timeZoneSettingsGetTimezonesQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'TimeZoneSettingsClient',
      'timeZoneSettingsGetTimezones',
    ]);
}
export function __timeZoneSettingsGetTimezones(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.timeZoneSettingsGetTimezones(
axiosConfig    );
}

/**
 * @return OK
 */
export function useTimeZoneSettingsGetTimezonesQuery<TSelectData = Types.NameValue[], TError = unknown>(options?: Omit<UseQueryOptions<Types.NameValue[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useTimeZoneSettingsGetTimezonesQuery<TSelectData = Types.NameValue[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.NameValue[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.NameValue[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __timeZoneSettingsGetTimezones(context, axiosConfig) : __timeZoneSettingsGetTimezones,
    queryKey: timeZoneSettingsGetTimezonesQueryKey(),
    ...timeZoneSettingsGetTimezonesDefaultOptions as unknown as Omit<UseQueryOptions<Types.NameValue[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setTimeZoneSettingsGetTimezonesData(queryClient: QueryClient, updater: (data: Types.NameValue[] | undefined) => Types.NameValue[], ) {
  queryClient.setQueryData(timeZoneSettingsGetTimezonesQueryKey(),
    updater
  );
}

/**
 * @return OK
 */
export function setTimeZoneSettingsGetTimezonesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.NameValue[] | undefined) => Types.NameValue[]) {
  queryClient.setQueryData(queryKey, updater);
}